import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import SectionTestimonials from 'components/blocks/SectionTestimonials'
import {ISectionTestimonialsItem} from 'components/blocks/SectionTestimonials/SectionTestimonials'
import {Container, Row, Col} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Testimonials.module.scss'
const cx = cn.bind(s)

interface IW2TestimonialsProps {
	className?: string
	content: IW2Content['testimonials']
}

/** W2Testimonials block component */
const W2Testimonials: FC<IW2TestimonialsProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col>
						<SectionTestimonials items={(content?.items as ISectionTestimonialsItem[]) || []} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2Testimonials.displayName = 'W2Testimonials'

export default W2Testimonials
